import { tillo as tilloApi } from '@huggg/back-bar';
import { combineReducers } from 'redux';
import initialStateLoader from '../initialState';

export const CLEAR = 'tillo-brand/CLEAR';
export const LOAD = 'tillo-brand/LOAD';
export const LOAD_SUCCESS = 'tillo-brand/LOAD_SUCCESS';
export const LOAD_FAILURE = 'tillo-brand/LOAD_FAILURE';

const defaultState = initialStateLoader().tillo;

const status = (state = defaultState.status, { type }) => {
  switch (type) {
    case LOAD:
      return {
        ...state,
        loaded: false,
        loading: true,
      };

    case LOAD_SUCCESS:
      return {
        ...state,
        loaded: true,
        loading: false,
      };

    case LOAD_FAILURE:
      return {
        ...state,
        loaded: true,
        loading: false,
      };

    case CLEAR:
      return {
        loaded: false,
        loading: false,
      };

    default:
      return state;
  }
};

const brand = (state = defaultState.brand, { type, payload }) => {
  switch (type) {
    case LOAD_SUCCESS:
      return {
        ...state,
        ...payload.brand,
      };

    case CLEAR:
      return {
        name: null,
        logoUrl: null,
        giftCardUrl: null,
      };

    default:
      return state;
  }
};

export default combineReducers({ brand, status });

export const fetchBrandAssets = (tilloBrand) => (dispatch) => {
  dispatch({ type: LOAD });

  if (tilloBrand.toLowerCase().includes('tesco')) {
    tilloBrand = 'tesco';
  }

  tilloApi
    .getBrandAssets(tilloBrand)
    .then((data) => {
      dispatch({
        type: LOAD_SUCCESS,
        payload: {
          brand: {
            name: tilloBrand,
            logoUrl: data.logoUrl,
            giftCardUrl: data.giftCardUrl,
          },
        },
      });
    })
    .catch(() => {
      dispatch({
        type: LOAD_FAILURE,
      });
    });
};

export const clearBrandAssets = () => (dispatch) => dispatch({ type: CLEAR });
export const getBrandAssets = (state) => state.tillo.brand;
export const getHasLoaded = (state) => state.tillo.status.loaded;
export const getIsLoading = (state) => state.tillo.status.loading;
